let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fxQEd")).then(() => parcelRequire('dYPsS'));